module.exports = __webpack_public_path__ + "assets/adpoly-facility-parking-helipads-bulk-upload-template.75da299b.xlsx";